import { render, staticRenderFns } from "./sopEmailRecord.vue?vue&type=template&id=5695d755&scoped=true&"
import script from "./sopEmailRecord.vue?vue&type=script&lang=js&"
export * from "./sopEmailRecord.vue?vue&type=script&lang=js&"
import style0 from "./sopEmailRecord.vue?vue&type=style&index=0&id=5695d755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695d755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5695d755')) {
      api.createRecord('5695d755', component.options)
    } else {
      api.reload('5695d755', component.options)
    }
    module.hot.accept("./sopEmailRecord.vue?vue&type=template&id=5695d755&scoped=true&", function () {
      api.rerender('5695d755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMonitor/sopEmailRecord.vue"
export default component.exports